import { get } from './chartingRepositoryClient';
import { normalizeChartingOhlcSeries } from '../adapters/chartingInsightsAdapters';
import { buildEngulfingDetail } from '../models/chartingEngulfing';

export async function fetchChartingEngulfingDetail(ticker, candidate) {
    const symbol = String(ticker || '').trim().toUpperCase();
    if (!symbol || !candidate || !Number.isFinite(candidate.monthStart) || !Number.isFinite(candidate.monthEnd) || candidate.monthEnd <= candidate.monthStart) {
        throw new Error('No se puede cargar este mes.');
    }
    const payload = await get('/stockchart/api/history', { params: {
        symbol, resolution: 'D', from: candidate.monthStart, to: candidate.monthEnd - 1
    } });
    const series = normalizeChartingOhlcSeries(payload);
    if (!['ok', 'no_data'].includes(series.status)) throw new Error('No se pudo cargar el desglose.');
    return buildEngulfingDetail(candidate, series.candles);
}
